export { default as TtBurgerIcon } from './burger-tt-white.svg'
export { default as ChevronRightIcon } from './chevron-right-black.svg'
export { default as ChevronSliderLeftIcon } from './chevron-slider-left.svg'
export { default as ChevronSliderRightIcon } from './chevron-slider-right.svg'
export { default as ClockIcon } from './clock.svg'
export { default as CustomMarkerIcon } from './custom-marker.svg'
export { default as InstagramBurgerWhiteIcon } from './instagram-burger-white.svg'
export { default as InstagramHeaderBlackIcon } from './instagram-header-black.svg'
export { default as InstagramHeaderWhiteIcon } from './instagram-header-white.svg'
export { default as InstagramWhiteIcon } from './instagram-white.svg'
export { default as LinkedinBurgerWhiteIcon } from './linkedin-burger-white.svg'
export { default as LinkedinWhiteIcon } from './linkedin-white.svg'
export { default as LocationIcon } from './location.svg'
export { default as MailIcon } from './mail.svg'
export { default as PhoneBlackIcon } from './phone-black.svg'
export { default as PhoneIcon } from './phone.svg'
export { default as PhoneWhiteIcon } from './phone-white.svg'
export { default as PlayIcon } from './play-icon.svg'
export { default as QuoteIcon } from './quote.svg'
export { default as StarIcon } from './star.svg'
export { default as TelegramBurgerWhiteIcon } from './telegram-burger-white.svg'
export { default as TelegramHeaderBlackIcon } from './telegram-header-black.svg'
export { default as TelegramHeaderWhiteIcon } from './telegram-header-white.svg'
export { default as TelegramWhiteIcon } from './telegram-white.svg'
export { default as TtWhiteIcon } from './tt-white.svg'
export { default as WhatsappBlackIcon } from './whatsapp-black.svg'
export { default as WhatsappBurgerWhiteIcon } from './whatsapp-burger-white.svg'
export { default as WhatsappHeaderBlackIcon } from './whatsapp-header-black.svg'
export { default as WhatsappHeaderWhiteIcon } from './whatsapp-header-white.svg'
export { default as WhatsappWhiteHeaderIcon } from './whatsapp-white-header.svg'
export { default as WhatsappWhiteIcon } from './whatsapp-white.svg'
export { default as YoutubeBurgerWhiteIcon } from './youtube-burger-white.svg'
export { default as YoutubeWhiteIcon } from './youtube-white.svg'
export { default as PlanetIcon } from './planet.svg'
